export interface IndexedRoute {
  path: string
}

// Indexed for all locales. Pages can also opt in with `shouldBeIndexed`.
export const indexedRoutes: IndexedRoute[] = [
  { path: '/' },
  { path: '/giftcard/' },
  { path: '/teamevent/' },
  { path: '/partner/' },
  { path: '/sitemap/' },
  { path: '/faq/' },
  { path: '/terms-and-conditions/' },
  { path: '/impressum/' },
  { path: '/kits/' },
  { path: '/b2c/private-events/' },
  { path: '/magazine/' },
]
